module.exports = __webpack_public_path__ + "img/crossy_road_small_detail.3ad1d6eb.png";